<template>
  <LazyHydrate when-idle>
    <div
      class="submenu"
    >
      <b-container>
        <nav class="submenu__content-wrapper">
          <span class="submenu__root-link-wrapper">
            <span
              class="submenu__root--text"
            >
              {{ getSubMenu.root.name }}
            </span>
            <span
              class="submenu__menu d-inline d-md-none"
              @click="toggleMenu"
            >
              Menu
              <img
                class="submenu__arrow"
                src="~/assets/images/icons/i-arrow-down.svg"
              />
            </span>
          </span>

          <CollapseTransition>
            <ul
              v-show="showMenu"
              class="submenu__list"
              transition="expand"
            >
              <li
                v-for="url in getSubMenu.urls"
                :key="url.name"
                class="submenu__line"
              >
                <ZLink
                  :href="url.path"
                  :class="{ 'submenu__link--active': url.active }"
                  :target=" url.targetBlank ? '_blank' : '_self' "
                  class="submenu__link submenu__link--text"
                  @click="() => toggleDropdown(url)"
                >
                  {{ url.name }}
                  <img
                    v-if="url.type === 'multiple'"
                    class="submenu__arrow"
                    src="~/assets/images/icons/i-arrow-down.svg"
                  />
                </ZLink>

                <CollapseTransition>
                  <ul
                    v-show="dropdownController[url.name]"
                    v-if="url.type === 'multiple'"
                    class="submenu__content"
                  >
                    <li
                      v-for="value in url.values"
                      :key="value.name"
                      class="submenu__list-item"
                    >
                      <ZLink
                        :href="value.path"
                        :class="{ 'submenu__link--active': value.active }"
                        :target=" value.targetBlank ? '_blank' : '_self' "
                        class="submenu__list-link submenu__list-link--arrow-before"
                        @click="() => toggleDropdownSubmenu(value)"
                      >
                        <span class="submenu__item-text ">
                          {{ value.name }}
                        </span>
                      </ZLink>

                      <CollapseTransition>
                        <ul
                          v-show="subDropdownController[value.name]"
                          v-if="value.type === 'multiple'"
                          class="submenu__content submenu__content--sub"
                        >
                          <li
                            v-for="subvalue in value.values"
                            :key="subvalue.name"
                            class="submenu__list-item"
                          >
                            <ZLink
                              :href="subvalue.path"
                              class="submenu__list-link submenu__list-link--arrow-before submenu__list-link--sub"
                            >
                              <span class="submenu__item-text ">
                                {{ subvalue.name }}
                              </span>
                            </ZLink>
                          </li>
                        </ul>
                      </CollapseTransition>
                    </li>
                  </ul>
                </CollapseTransition>
              </li>
            </ul>
          </CollapseTransition>
        </nav>
      </b-container>
    </div>
  </LazyHydrate>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { CollapseTransition } from 'vue2-transitions';
import LazyHydrate from 'vue-lazy-hydration';
import { ZLink } from '@quero/zilla-vue'

export default {
  computed: {
    ...mapGetters('submenu', [
      'getSubMenu',
    ]),
  },
  components: {
    CollapseTransition,
    LazyHydrate,
    ZLink,
  },
  data() {
    return {
      dropdownController: () => {},
      subDropdownController: () => {},
      showMenu: false,
    };
  },
  methods: {
    toggleDropdown(url) {
      this.dropdownController = {
        [url.name]: !this.dropdownController[url.name],
      };

      this.subDropdownController = {};
    },
    toggleDropdownSubmenu(url) {
      this.subDropdownController = {
        [url.name]: !this.subDropdownController[url.name],
      };
    },
    toggleMenu() {
      this.showMenu = !this.showMenu;

      if (!this.showMenu) {
        this.dropdownController = {};
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '@quero/zilla-core/src/utils/functions.scss';
  @import '@quero/zilla-core/src/utils/variables.scss';

  .submenu {
    background-color: var(--color-brand-primary-pure);
    display: flex;
    justify-content: center;
    user-select: none;
    width: 100%;
  }

  .submenu__content-wrapper {
    display: flex;
    flex-direction: column;
    max-width: 100%;
    width: 100%;

    @media (min-width: $screen-md-min) {
      flex-direction: row;
    }
  }

  .submenu__root-link-wrapper {
    align-items: center;
    display: flex;
    justify-content: space-between;
    min-width: 0;
  }

  .submenu__root--text{
    color: var(--color-neutral-white);
    height: 23px;
    font-size: rem(16);
    font-weight: $font-weight-bold;
    margin-right: $space-xl;
    width: 49px;
  }

  .submenu__link {
    color: var(--color-neutral-white);
    cursor: pointer;
    display: block;
    font-size: rem(16);
    font-weight: $font-weight-bold;
    line-height: rem(14);
    padding: $space-m;
    text-decoration: none;

    &:visited,
    &:active,
    &:hover {
      color: var(--color-neutral-white);
    }

    @media (min-width: $screen-md-min) {
      &:hover {
        background-color: var(--color-brand-primary-deep)
      }
    }
  }

  .submenu__link--active {
    background-color: var(--color-brand-primary-deep)
  }

  .submenu__link--text.submenu__link--text {
    text-decoration: none;
  }

  .submenu__content {
    background-color: var(--color-brand-primary-pure);
    padding-left: 0px;
    position: relative;
    transition: max-height 0.1s ease-in-out;

    @media (min-width: $screen-md-min) {
      position: absolute;
      z-index: 1;
    }
  }

  .submenu__content--sub {
    @media (min-width: $screen-md-min) {
      left: 100%;
      top: 0px;
    }
  }

  .submenu__list-item {
    list-style: none;
    min-width: 160px;
    position: relative;

    &:first-child > .submenu__list-link {
      padding-top: $space-s;

      @media (min-width: $screen-md-min) {
        padding-top: $space-xs;
      }
    }

    &:last-child > .submenu__list-link {
      padding-bottom: $space-s;

      @media (min-width: $screen-md-min) {
        padding-bottom: $space-xs;
      }
    }
  }

  .submenu__menu {
    color: var(--color-neutral-white);
    cursor: pointer;
    font-size: rem(16);
    font-weight: $font-weight-bold;
    line-height: rem(14);
    padding: $space-m 0;
    align-items: center;
  }

  .submenu__arrow {
    display: inline-block;
    margin-left: $space-s;
    vertical-align: middle;
  }

  .submenu__list {
    background-color: var(--color-brand-primary-pure);
    list-style: none;
    margin-bottom: 0;
    margin-top: 0;
    padding-left: 0;

    @media (min-width: $screen-md-min) {
      background-color: transparent;
      /* its important because it needs to override an transition default style */
      display: flex!important;
    }
  }

  .submenu__list-link {
    color: var(--color-neutral-white);
    cursor: pointer;
    display: block;
    font-size: rem(14);
    line-height: rem(20);
    padding: $space-xs $space-st;
    text-decoration: none;

    @media (min-width: $screen-md-min) {
      padding: $space-xs $space-m;

      &:hover {
        background-color: var(--color-brand-primary-deep)
      }
    }
  }

  .submenu__list-link--sub {
    padding: $space-xxs $space-xl;

    @media (min-width: $screen-md-min) {
      padding: $space-xs $space-m;
    }
  }

  .submenu__list-link--arrow-before {
    &::before {
      content: '\203a';
      font-size: rem(18);
      margin-right: $space-xs;
    }
  }

  .submenu__line {
    white-space: nowrap;
  }
</style>
